/**
 * Returns a string with the number and the correct pluralized form of the word,
 * using Intl.PluralRules for locale-aware pluralization.
 *
 * @param {number} count - The number to use for pluralization.
 * @param {string} word - The base word to pluralize.
 * @param {Object} [options] - Optional settings.
 * @param {string} [options.locale='en'] - The locale to use.
 * @param {Object} [options.plurals] - Custom plural forms, e.g. {one: 'item', other: 'items'}
 * @returns {string} - The formatted string, e.g. "2 items"
 */
export function getPlural(count, word, options = {}) {
    const locale = options.locale || 'en';
    const plurals = options.plurals || { one: word, other: word + 's' };
    const pr = new Intl.PluralRules(locale);
    const rule = pr.select(count);
    const pluralWord = plurals[rule] || plurals.other;
    return `${count} ${pluralWord}`;
}